import { apiSlice } from '../api/apiSlice'
import { updateUserProfile } from '../features/userSlice'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getOrgVerifyRequests: builder.query({
      query: () => ({
        url: '/organizations/verify-requests/',
        method: 'GET',
      }),
      providesTags: ['Org-Verification-Requests'],
    }),
    getAllReports: builder.query({
      query: ({year, month, query}) => ({
        url: `/reports/all-reports/?month=${month}&year=${year}&query=${query}`,
        method: 'GET',
      }),
    }),
    getOrgReports: builder.query({
      query: () => ({
        url: '/reports/organization-reports/',
        method: 'GET',
      }),
      providesTags: ['Org-Reports'],
    }),
    createReport: builder.mutation({
        query: (reportObj) => ({
          url: `/reports/organization-reports/`,
          method: 'POST',
          body: reportObj
        }),
        invalidatesTags: ['Org-Reports'],
      }),
    editOrgProfile: builder.mutation({
        query: profileObj => ({
            url: '/organizations/edit-profile/',
            method: 'PATCH',
            body: profileObj
        }),
        async onQueryStarted( profileObj, { dispatch, queryFulfilled }) {
            try {
              const { data: profile } = await queryFulfilled
              dispatch(updateUserProfile(profile))
            } catch (err) {
              console.error('Failed to add item', err)
            }
        }
    }),
    updateOrgUserPassword: builder.mutation({
        query: (newInfo) => ({
          url: '/organizations/update-password/',
          method: 'PATCH',
          body: newInfo
        }),
      }),
    orgVerifyRequest: builder.mutation({
      query: (profileInfo) => ({
        url: '/organizations/verify-requests/',
        method: 'POST',
        body: profileInfo
      }),
    }),
    handleOrgVerifyRequest: builder.mutation({
      query: (decisionInfo) => ({
        url: '/organizations/handle-verify-request/',
        method: 'PATCH',
        body: decisionInfo
      }),
      invalidatesTags: ['Org-Verification-Requests'],
    }),
  })
})

export const { 
  useGetOrgVerifyRequestsQuery,
  useGetAllReportsQuery,
  useGetOrgReportsQuery,
  useCreateReportMutation, 
  useEditOrgProfileMutation, 
  useUpdateOrgUserPasswordMutation, 
  useOrgVerifyRequestMutation,
  useHandleOrgVerifyRequestMutation,
 } = extendedApiSlice